import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material/utils";
const PlayIcon = createSvgIcon(/* @__PURE__ */ jsx("svg", { width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("g", { id: "prefix__icons/play", children: /* @__PURE__ */ jsx("path", { id: "prefix__Polygon 3", d: "M23.7448 14.4274C25.0781 15.1972 25.0781 17.1217 23.7448 17.8915L11.7945 24.7909C10.7945 25.3683 9.54455 24.6466 9.54455 23.4919L9.54455 8.82694C9.54455 7.67224 10.7945 6.95056 11.7945 7.52791L23.7448 14.4274Z" }) }) }), "PlayIcon");
export {
  PlayIcon
};
